/* @flow */

import * as React from "react";

import * as _ from "lodash";
import CountryUtil from "shared/src/uidispatcherapi/CountryUtil";
import { SessionStore } from "shared/src/uidispatcherapi/SessionStore";
type Props = {};

// declare the web component for TypeScript
declare global {
    namespace JSX {
        interface IntrinsicElements {
            "cms-store-flyout": any;
        }
    }
}

export class MetroXStoreSelector extends React.Component<Props> {
    componentRef: React.RefObject<Element> = React.createRef();

    constructor(props: Props) {
        super(props);
    }

    componentDidMount() {
        const siteCoreBaseUrl = _.get(
            CountryUtil.getOptionalConfig(),
            "siteCoreBaseUrl",
            "https://www-dev2-sc.metro.de"
        );

        const scriptStoreSelector = document.createElement("script");
        scriptStoreSelector.src = `${siteCoreBaseUrl}/data/apps/mshop?sc_device=webcomponent&components=store%20flyout`;

        if (document.head) {
            document.head.appendChild(scriptStoreSelector);
        }

        if (this.componentRef.current) {
            this.componentRef.current.addEventListener("cms:store-flyout:change", this.handleStoreHasBeenSelected);
        }
    }

    handleStoreHasBeenSelected = (ev: any) => {
        const bettyStoreId = SessionStore.mapToBettyStoreId(ev.storeid);
        SessionStore.setSelectedStoreId(bettyStoreId);
    };

    render() {
        return <cms-store-flyout ref={this.componentRef} storeid={SessionStore.getCustomerStore()} />;
    }
}
